/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickets_Api_Errors_Cannot_Delete_First_MessageInputs */

const nl_tickets_api_errors_cannot_delete_first_message = /** @type {(inputs: Tickets_Api_Errors_Cannot_Delete_First_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je eerste bericht is de vraag zelf en kan niet worden verwijderd. Sluit het ticket als je vraag niet meer speelt.`)
};

/**

* @param {Tickets_Api_Errors_Cannot_Delete_First_MessageInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const tickets_api_errors_cannot_delete_first_message = /** @type {((inputs?: Tickets_Api_Errors_Cannot_Delete_First_MessageInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickets_Api_Errors_Cannot_Delete_First_MessageInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_tickets_api_errors_cannot_delete_first_message(inputs)
});
export { tickets_api_errors_cannot_delete_first_message as "tickets.api_errors.cannot_delete_first_message" }